import { render, staticRenderFns } from "./lottery_config.vue?vue&type=template&id=51116448&scoped=true"
import script from "./lottery_config.vue?vue&type=script&lang=js"
export * from "./lottery_config.vue?vue&type=script&lang=js"
import style0 from "./lottery_config.vue?vue&type=style&index=0&id=51116448&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51116448",
  null
  
)

export default component.exports